// extracted by mini-css-extract-plugin
module.exports = {"documents":"DocumentsSection_documents__2qQg3","docs":"DocumentsSection_docs__2Dxfv"};